"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferSchema = exports.PartnerSchema = exports.IOfferType = exports.getOfferwallTypeLabel = exports.isMfoLikeOfferwallType = exports.normalizeOfferwallType = exports.MfoLikeOfferwallTypes = exports.OfferwallTypes = void 0;
const mongoose_1 = require("mongoose");
exports.OfferwallTypes = ['BASE', 'MFO', 'GAMBLING_NEW'];
exports.MfoLikeOfferwallTypes = ['MFO', 'GAMBLING_NEW'];
const normalizeOfferwallType = (offerwallType) => {
    return exports.OfferwallTypes.includes(offerwallType)
        ? offerwallType
        : 'BASE';
};
exports.normalizeOfferwallType = normalizeOfferwallType;
const isMfoLikeOfferwallType = (offerwallType) => {
    return exports.MfoLikeOfferwallTypes.includes((0, exports.normalizeOfferwallType)(offerwallType));
};
exports.isMfoLikeOfferwallType = isMfoLikeOfferwallType;
const getOfferwallTypeLabel = (offerwallType) => {
    const normalized = (0, exports.normalizeOfferwallType)(offerwallType);
    if (normalized === 'GAMBLING_NEW')
        return 'Gambling [email]';
    if (normalized === 'MFO')
        return 'MFO';
    return 'Gambling';
};
exports.getOfferwallTypeLabel = getOfferwallTypeLabel;
var IOfferType;
(function (IOfferType) {
    IOfferType["GAMBLING"] = "gambling";
    IOfferType["BETTING"] = "betting";
    IOfferType["FIN"] = "fin";
})(IOfferType = exports.IOfferType || (exports.IOfferType = {}));
exports.PartnerSchema = new mongoose_1.Schema({
    partnerId: Number,
    shortName: String,
    name: String
});
exports.OfferSchema = new mongoose_1.Schema({
    id: { type: Number, unique: true },
    name: String,
    graphicFolder: String,
    graphic: {
        logo: String,
        bg: String
    },
    geo: String,
    caption: String,
    link: String,
    partnerId: Number,
    type: {
        type: String,
        enum: IOfferType,
        default: IOfferType.GAMBLING
    },
    keitaroId: String,
    generatedKey: String,
    offerwallType: {
        type: String,
        enum: exports.OfferwallTypes,
        default: 'BASE'
    },
    texts: [String],
    noBackground: Boolean,
    emoji: String,
    hidden: Boolean,
    history: {
        link: [String],
        logoNames: [String],
        bgNames: [String],
        name: [String],
        caption: [String]
    }
});
